import API from '@aws-amplify/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import i18n from '../../../../i18n';
import React, { useContext, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { ProtectedRouteContext } from '../../../Context';

import './Checkboxes.scss';

export default function Checkboxes(props) {
    //TODO emit my saving status to parent component

    const question = props.question;
    const shouldShowErrors = props.shouldShowErrors;
    const disabled = props.disabled;
    const appInstanceId = props.appInstanceId;
    const answerUpdated = props.answerUpdated;
    const previouslyChosen = question.chosenOptions.filter((a) => {
        return !!a;
    });

    const [t] = useTranslation();
    const { userSettings } = useContext(ProtectedRouteContext);
    const [lang, setLang] = useState(
        typeof userSettings?.LanguagePreference === 'string' ? userSettings.LanguagePreference : i18n.language
    );
    const [chosenVals, setChosenVals] = useState(previouslyChosen);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (typeof userSettings?.LanguagePreference === 'string') {
            setLang(userSettings.LanguagePreference);
        }
    }, [userSettings.LanguagePreference]);

    const onValueChange = async (event) => {
        const toggledId = parseInt(event.target.value);
        const previousIndex = chosenVals.indexOf(toggledId);
        var newChosenVals = [];
        if (previousIndex < 0) {
            newChosenVals = [...chosenVals, toggledId];
        } else {
            newChosenVals = chosenVals.filter((_a, i) => {
                return i !== previousIndex;
            });
        }

        setSaving(true);

        try {
            var updateAnswerResponse = await API.put('ShipyardAPI', `/application/${appInstanceId}/answer/${question.id}`, {
                body: { responseIds: newChosenVals },
            });
        } catch (apiErr) {
            toast.error(t('General.AjaxError'));
            return;
        }

        if (!updateAnswerResponse.success) {
            toast.error(t('General.AjaxError'));
            return;
        }

        question.chosenOptions = newChosenVals;
        setChosenVals(newChosenVals);
        var validity = question.validator(question);
        question.isValid = validity.isValid;
        question.invalidReason = validity.invalidReason;
        answerUpdated();
        setSaving(false);
    };

    return (
        <div
            className={
                'question-wrapper checkbox' + (!question.isValid && shouldShowErrors ? ' invalid' : '') + (disabled ? ' disabled' : '')
            }
        >
            <div
                className={classNames({
                    label: true,
                    required: question.minResponseRequired > 0,
                })}
            >
                <ReactMarkdown
                    children={question.text[lang]}
                    linkTarget="_blank"
                />
            </div>
            <span className="invalid-reason">
                {question.isValid
                    ? ''
                    : typeof question.invalidReason === 'string'
                      ? t(question.invalidReason, { max: question.maxResponseRequired, min: question.minResponseRequired })
                      : ''}
            </span>
            {question.options.map((option) => {
                let isSelected = chosenVals.indexOf(option.id) >= 0;
                return (
                    <div
                        className="checkbox-option"
                        key={option.id}
                    >
                        {saving ? (
                            <div className="saving">
                                <FontAwesomeIcon icon={faSpinner} />
                            </div>
                        ) : null}
                        {!saving ? (
                            <div className="input-wrap">
                                <input
                                    type="checkbox"
                                    id={`quest-${question.id}-opt-${option.id}`}
                                    value={option.id}
                                    checked={isSelected}
                                    disabled={saving}
                                    onChange={onValueChange}
                                />
                            </div>
                        ) : null}

                        <label htmlFor={`quest-${question.id}-opt-${option.id}`}>{option.text[lang]}</label>
                    </div>
                );
            })}
        </div>
    );
}
